import { Tabs as MantineTabs, TabsProps as MantineTabsProps } from '@mantine/core';

import tabsStyles from './Tabs.module.css';
import { cva, VariantProps } from 'class-variance-authority';
import { JSX } from 'react';

export interface TabsProps extends Omit<MantineTabsProps, 'variant'> {
    variant: VariantProps<typeof tabsVariants>['variant'];
}

const tabsVariants = cva(tabsStyles.base, {
    variants: {
        variant: {
            pill: tabsStyles.pill,
            underline: tabsStyles.underline,
        },
    },
    defaultVariants: {
        variant: 'pill',
    },
});

export const Tabs: typeof MantineTabs & {
    (props: TabsProps): JSX.Element;
} = Object.assign(({ variant, ...props }: TabsProps) => {
    /**
     * Setting default variant to 'default' to play nicely with Mantine's Tab styles
     * and overriding those styles with our internal variants.
     */
    return <MantineTabs className={tabsVariants({ variant })} variant="default" {...props} />;
}, MantineTabs);
